// IMPORTANT: this file should have .js extension, because it should work in IE

function detectEdgeOrIE() {
  var ieInfo = detectIE()
  if (ieInfo) {
    return ieInfo
  }

  var ua = window.navigator.userAgent
  var edge = ua.indexOf("Edge/")
  if (edge > 0) {
    // Edge (IE 12+) => return version number
    return parseInt(ua.substring(edge + 5, ua.indexOf(".", edge)), 10)
  }

  // other browser
  return false
}

function detectIE(ua) {
  var ua = window.navigator.userAgent

  var msie = ua.indexOf("MSIE ")
  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)), 10)
  }

  var trident = ua.indexOf("Trident/")
  if (trident > 0) {
    // IE 11 => return version number
    var rv = ua.indexOf("rv:")
    return parseInt(ua.substring(rv + 3, ua.indexOf(".", rv)), 10)
  }

  return false
}

module.exports = {
  detectEdgeOrIE,
  detectIE,
}
